var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$can('manage-collective-gateways', 'ipg-gateway'))?_c('main-content',{attrs:{"with_go_back_bar":""}},[_c('kt-datatable',_vm._b({ref:"datatable"},'kt-datatable',_vm.datatableProps,false))],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }